import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'

@connect(
  state => (state.wallet)
)
export default class Credits extends Component {

  render() {

    const {freePoints, credits} = this.props

    if (freePoints > 0) {

      return <span>
      Nemokami vertimai: <strong>{freePoints}</strong>
    </span>
    } else {

      return <span>
      Kreditai: <strong>{credits}</strong> | <a href="/knzona/kreditai.cfm" alt="" className='underline'>Pirkti kreditų</a>
    </span>
    }

  }
}
